import React from 'react';
import { Award, Users, CheckCircle } from 'lucide-react';

const WhyChooseSection = () => {
  const reasons = [
  {
    icon: Award,
    title: "AWS Cloud Solutions",
    description: "Delivering secure, scalable, and cost-effective cloud solutions built on Amazon Web Services."
  },
  {
    icon: Users,
    title: "Professional Team",
    description: "Our experienced professionals deliver reliable cloud solutions tailored to your business needs."
  },
  {
    icon: CheckCircle,
    title: "Customer-Focused Approach",
    description: "We work closely with clients to deliver reliable, scalable, and business-focused cloud solutions."
  }];


  return (
    <section className="py-20 bg-gradient-to-b from-[#020B1A] to-[#061426]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Why Choose Axora Cloud
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">Empowering businesses with secure, scalable, and reliable cloud solutions.

          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <div
                key={index}
                className="text-center group">

                <div className="w-20 h-20 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300" style={{ boxShadow: '0 0 30px rgba(0, 212, 255, 0.4)' }}>
                  <Icon className="w-10 h-10 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-4">{reason.title}</h3>
                <p className="text-gray-400 text-lg leading-relaxed">{reason.description}</p>
              </div>);

          })}
        </div>
      </div>
    </section>);

};

export default WhyChooseSection;